import React, { useState, useEffect } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  AppBar,
  Box,
  Toolbar,
  IconButton,
  Drawer,
  List,
  ListItem,
  ListItemText,
  useMediaQuery,
  Link,
  Button
} from "@mui/material";
import MenuIcon from "@mui/icons-material/Menu";
import Brightness4Icon from "@mui/icons-material/Brightness4";
import Brightness7Icon from "@mui/icons-material/Brightness7";
import { useTheme } from "@mui/material/styles";
import { useColorMode } from "../ColorModeContext";

const Header = ({ logo, darkLogo, navLinks = [], onLogout }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { mode, toggleColorMode } = useColorMode();

  const currentLogo = mode === "dark" && darkLogo ? darkLogo : logo;
  const inactiveLogo = mode === "dark" ? logo : darkLogo;

  useEffect(() => {
    if (!inactiveLogo) return;
    const id = requestIdleCallback(() => {
      const img = new Image();
      img.src = inactiveLogo;
    });
    return () => cancelIdleCallback(id);
  }, [inactiveLogo]);

  const toggleDrawer = (open) => () => {
    setDrawerOpen(open);
  };

  const themeToggleButton = (
    <IconButton onClick={toggleColorMode} sx={{ color: "text.primary" }} aria-label="toggle color mode">
      {mode === "dark" ? <Brightness7Icon /> : <Brightness4Icon />}
    </IconButton>
  );

  const renderDrawer = () => (
    <Drawer
      anchor="right"
      open={drawerOpen}
      onClose={toggleDrawer(false)}
      PaperProps={{
        sx: { bgcolor: "background.default" }
      }}
    >
      <Box
        sx={{ width: 250 }}
        role="presentation"
        onClick={toggleDrawer(false)}
        onKeyDown={toggleDrawer(false)}
      >
        <List>
          {navLinks.map((item) => (
            <ListItem button key={item.title} component={RouterLink} to={item.path}>
              <ListItemText primary={item.title} />
            </ListItem>
          ))}
          {onLogout && (
            <ListItem button onClick={onLogout}>
              <ListItemText primary="Logout" />
            </ListItem>
          )}
          <ListItem>
            {themeToggleButton}
          </ListItem>
        </List>
      </Box>
    </Drawer>
  );

  return (
    <AppBar
      position="sticky"
      sx={{
        bgcolor: "background.default",
        color: "text.primary",
        boxShadow: "none",
        borderBottom: 1,
        borderColor: "divider"
      }}
    >
      <Toolbar sx={{ justifyContent: "space-between", maxWidth: 1200, width: "100%", mx: "auto", px: { xs: 2, sm: 3 } }}>
        <RouterLink to="/" style={{ display: 'flex', alignItems: 'center' }}>
          <img src={currentLogo} style={{ cursor: 'pointer', height: 22 }} alt="Logo" />
        </RouterLink>

        {isMobile ? (
          <>
            <IconButton
              edge="end"
              onClick={toggleDrawer(true)}
              sx={{ color: "text.primary" }}
              aria-label="menu"
            >
              <MenuIcon />
            </IconButton>
            {renderDrawer()}
          </>
        ) : (
          <Box sx={{ display: "flex", gap: 2, alignItems: "center" }}>
            {navLinks.map((item) => (
              <Link
                key={item.title}
                component={RouterLink}
                to={item.path}
                underline="none"
                sx={{ color: "text.primary", fontSize: "1rem" }}
              >
                {item.title}
              </Link>
            ))}
            {onLogout && (
              <Button
                onClick={onLogout}
                sx={{ color: "text.primary", fontSize: "1rem", textTransform: "none" }}
              >
                Logout
              </Button>
            )}
            {themeToggleButton}
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
};

export default Header;
